<ng-container *ngIf="showSingular as departureOrReturn">
  <fin-booking-widget-selector
    class="flex flex-1"
    [disabled]="disabled"
    (click)="openModal()"
    [label]="'bookingSearch.boundSelection.' + departureOrReturn | finLocalization"
    [attr.data-test-travel-dates-selector]="departureOrReturn"
  >
    <span *ngIf="(travelDates$ | async)?.[departureOrReturn] as selectedDate" data-test-departure-date>{{
      selectedDate | finDateFormat: 'FULL_NO_YEAR'
    }}</span>
  </fin-booking-widget-selector>
</ng-container>

<ng-container *ngIf="!showSingular">
  <fin-booking-widget-selector
    class="flex"
    [ngClass]="{
      'flex--half border-right': (isOneway$ | async) === false,
      'flex-1': (isOneway$ | async)
    }"
    [disabled]="disabled"
    [label]="'bookingSearch.boundSelection.departureDate' | finLocalization"
    [attr.data-test-travel-dates-selector]="'departureDate'"
    (click)="openModal()"
  >
    <span *ngIf="(travelDates$ | async)?.departureDate as departureDate" data-test-departure-date>{{
      departureDate | finDateFormat: 'FULL_NO_YEAR'
    }}</span>
  </fin-booking-widget-selector>

  <div
    *ngIf="(isOneway$ | async) === false && showSeparator"
    class="flex flex--center flex--self-center absolute white-bg date-spacer ps-xxsmall"
  >
    <fcom-icon name="minus" class="is-small"></fcom-icon>
  </div>

  <fin-booking-widget-selector
    *ngIf="(isOneway$ | async) === false"
    class="flex flex--half"
    [disabled]="disabled"
    [label]="'bookingSearch.boundSelection.returnDate' | finLocalization"
    [separatorPadding]="'all'"
    [attr.data-test-travel-dates-selector]="'returnDate'"
    (click)="openModal()"
  >
    <span *ngIf="(travelDates$ | async)?.returnDate as returnDate" data-test-return-date>{{
      returnDate | finDateFormat: 'FULL_NO_YEAR'
    }}</span>
  </fin-booking-widget-selector>
</ng-container>

<fcom-modal
  [(open)]="modalOpen"
  [fitToContent]="true"
  [buttons]="null"
  [roundedContent]="true"
  [fullHeight]="true"
  [extraWide]="true"
  data-test-travel-dates-modal
>
  <fcom-datepicker
    *ngIf="modalOpen && ('datepicker' | finLocalization) as uiLabels"
    [uiLabels]="uiLabels"
    [dateLabels]="'date' | finLocalization"
    [title]="'priceCalendar.title' | finLocalization"
    [isDateRange]="(isOneway$ | async) === false"
    [selectableDatesRange]="calendarRange"
    [disabledDateRanges]="[[]]"
    [selectedDates]="[(travelDates$ | async)?.departureDate, (travelDates$ | async)?.returnDate]"
    [doneBtnHidden]="true"
    [showChips]="false"
    [headerTemplate]="(prices$ | async)?.histogram ? calendarHeader : undefined"
    [dayTemplate]="dayTemplate"
    [selectMonthIndex]="selectedHistogramMonth$ | async"
    [calendarScrollEnabled]="true"
    (selectedDatesChange)="updateCalendarDates($event)"
    (close)="closeModal()"
    (monthChange)="setHistogramMonth($event.monthArrayIndex)"
  ></fcom-datepicker>

  <!-- custom modal footer -->
  <div class="flex flex--middle flex--center flex--space-between ps-large-x grey-50-bg font-body-1 ps-small">
    <span>
      <span>{{ 'priceCalendar.perAdult' | finLocalization }} </span>
      <span class="bold-type">{{ pricePerAdult$ | async | finPrice: true : true | finEmpty: '&ndash;' }}</span>
    </span>
    <span class="flex flex--middle flex--center">
      <fcom-checkbox
        [name]="'flexibleDates'"
        [checked]="flexibleDates"
        [disabled]="false"
        (change)="setFlexibleDates.emit($event)"
        data-test-flexible-dates
      >
        <span>{{ 'priceCalendar.flexibleDates' | finLocalization }}</span>
      </fcom-checkbox>

      <fcom-button
        [size]="ButtonSize.R_SMALL"
        [text]="'actions.done' | finLocalization"
        (click)="closeModal()"
      ></fcom-button>
    </span>
  </div>
</fcom-modal>

<ng-template #calendarHeader>
  <fin-histogram
    [barData$]="prices$ | finMap: 'histogram'"
    [selected$]="selectedHistogramMonth$"
    (barSelected)="handleHistogramClick($event)"
    (barsScrolled)="handleBarsScrolled($event)"
  ></fin-histogram>
</ng-template>

<ng-template #dayTemplate let-dayValue="dayValue" let-dayString="dayString">
  <div
    class="calendar-day"
    *finLet="(prices$ | async)?.calendar?.[dayValue.id] as price"
    [attr.data-test-calendar-day]="dayValue.id"
  >
    <div class="ps-xxsmall-t">{{ dayString }}</div>

    <div
      *ngIf="(prices$ | async)?.calendar"
      class="calendar-day-price font-body-2 regular-type"
      [ngClass]="{
        'heather-700-text bold-type': price?.isLowestPrice
      }"
      [attr.data-test-calendar-price]="dayValue.id"
    >
      <ng-container
        *ngTemplateOutlet="
          priceTemplate;
          context: {
            amount:
              dayValue.id >= (travelDates$ | async)?.departureDate?.id &&
              dayValue.id < (travelDates$ | async)?.returnDate?.id &&
              (isOneway$ | async) === false
                ? undefined
                : price?.amount
          }
        "
      ></ng-container>
    </div>
    <ng-template #priceTemplate let-amount="amount">
      {{ amount | finPrice: false : true : false : true | finEmpty: '&nbsp;' }}
    </ng-template>

    <div
      *ngIf="price"
      class="day-border fill absolute"
      [class.birch-300-bg]="!price?.noFlight"
      [class.grey-400-bg]="price?.noFlight"
      [attr.data-test-calendar-price-border]="dayValue.id"
    ></div>
  </div>
</ng-template>
